import React from 'react'
import { navigate } from "@reach/router";
import { ListGroup } from "react-bootstrap";
import moment from "moment";

const ListaPropuestas = ({propuestas}) => {

    if (propuestas.length === 0) return <p>No hay propuestas</p>

    return <>
    {propuestas.map((propuesta) => {
        const fecha = moment(propuesta.fecha);

        return (
          <ListGroup.Item
            className="is-clickable"
            key={propuesta.fecha}
            onClick={() =>
              navigate("/admin/revision/" + propuesta._id)
            }
          >
            {propuesta.articulo ? (
              <>
                <i
                  className="fa fa-edit is-white"
                  aria-hidden="true"
                ></i>{" "}
                Edición para{" "}
              </>
            ) : (
              <>
                <i
                  className="fa fa-file-alt is-white"
                  aria-hidden="true"
                ></i>{" "}
                Creación de{" "}
              </>
            )}
            /articulo/<strong>{propuesta.titulo}</strong> por{" "}
            <span className="is-white">{propuesta.autor?.displayName}</span>
            <br />
            <span
              style={{ fontSize: "90%", color: "rgb(82, 83, 90)" }}
            >
              {fecha.fromNow()} ({fecha.format("LLL")})
            </span>
          </ListGroup.Item>
        );
      })}
    </>
}

export default ListaPropuestas